import { FC, ReactNode } from "react";
import dynamic from "next/dynamic";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });
import animationData from "@/public/lottie/page-loading.json";

interface IPageLoadingProps {
  isOpen: boolean;
}

const PageLoading: FC<IPageLoadingProps> = ({ isOpen }): ReactNode => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "var(--color-darker)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999
      }}
    >
      <Lottie
        animationData={animationData}
        style={{
          width: 300,
          height: 300
        }}
        loop
      />
    </div>
  );
};

export default PageLoading;
